<table class="table table-bordered table-hover">
  <thead class="table-dark">
    <tr>
      <th>Client</th>
      <th>Encounter Type</th>
      <th>Earliest<br /> Record</th>
      <th>Last<br/> Received</th>
      <th>Encounters Count</th>
      <th>Current Eligibility Status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    @for (encounterTypeEligibilitySummary of encounterTypeEligibilitySummaries; track trackBySummary($index, encounterTypeEligibilitySummary)) {
      <tr>
        <td>{{ encounterTypeEligibilitySummary.clientName }}</td>
        <td>{{ encounterTypeEligibilitySummary.encounterType }}</td>
        <td>{{ encounterTypeEligibilitySummary.earliestEncounterDate | date: 'MM/dd/yyyy' | blankValueDash }}</td>
        <td>{{ encounterTypeEligibilitySummary.latestEncounterDate | date: 'MM/dd/yyyy' | blankValueDash }}</td>
        <td>{{ encounterTypeEligibilitySummary.encounterCount }}</td>
        <td class="eligibility-status" [ngClass]="encounterTypeEligibilitySummary.eligibilityStatus">
          {{ keyedEligibilityStatusOptions[encounterTypeEligibilitySummary.eligibilityStatus].display }}
        </td>
        @if(encounterTypeEligibilitySummary.encounterTypeIneligibleByDefaultEnabled) {
          <td class="text-nowrap">
            @switch(encounterTypeEligibilitySummary.eligibilityStatus) {
              @case(eligibilityStatuses.new) {
                <button
                  type="button"
                  class="btn btn-secondary action-button"
                  (click)="onMarkEligibleClick(encounterTypeEligibilitySummary)">
                  Mark Eligible
                </button>
                <button
                  type="button"
                  class="btn btn-secondary action-button"
                  (click)="onMarkIneligibleClick(encounterTypeEligibilitySummary)">
                  Mark Ineligible
                </button>
              }
              @case(eligibilityStatuses.eligible) {
                <button
                  type="button"
                  class="btn btn-secondary action-button"
                  (click)="onMarkIneligibleClick(encounterTypeEligibilitySummary)">
                  Mark Ineligible
                </button>
              }
              @case(eligibilityStatuses.ineligible) {
                <button
                  type="button"
                  class="btn btn-secondary action-button"
                  (click)="onMarkEligibleClick(encounterTypeEligibilitySummary)">
                  Mark Eligible
                </button>
              }
            }
          </td>
        } @else {
          <td class="bg-light">This client does not manage encounter data in the app</td>
        }
      </tr>
    }
  </tbody>
</table>